export default {"src":"/_next/static/image/public/home/shipping-label.305e81e4ae8534f81a7c9a52049c9216.svg","height":142,"width":141};